// ─── Vánoční focení ───────────────────────────────────────────────────────
// Texty a nastavení rezervační sekce na webu – všechno se mění tady.
//
// Termíny, cena, záloha, místo, co je v ceně, obsazenost a podmínky
// rezervace sem NEPATŘÍ: chodí z backendu (hrachovenachova-be,
// src/config/reservations.ts), aby web, potvrzovací e-mail a server nikdy
// neukazovaly něco jiného.

/** Kotva sekce – odkaz na sdílení: hrachovenachova.cz/#vanoce */
export const CHRISTMAS_SECTION_ID = 'vanoce';

/**
 * Ruční vypínač – false = sekce i odkazy v menu jsou skryté bez ohledu na
 * data níže. Zpět zapnout přepnutím na true (a nasazením).
 */
// Anotace boolean: je to přepínač – s typem „false“ by TypeScript bral
// podmínky s ním jako vždy nepravdivé
export const SHOW_CHRISTMAS: boolean = true;

/**
 * Od tohoto okamžiku se sekce i odkazy v menu samy objeví – do té doby je
 * rezervace skrytá (zveřejnění bez dalšího nasazování).
 */
export const CHRISTMAS_STARTS = '2026-10-13T17:00:00+02:00';

/**
 * Od tohoto dne (včetně, pražský čas) se sekce i odkazy v menu samy skryjí –
 * po akci není potřeba nic mazat ani nasazovat.
 */
export const CHRISTMAS_ENDS = '2026-11-09';

export const CHRISTMAS_TITLE = 'Vánoční focení';
export const CHRISTMAS_SUBTITLE = 'Sobota 7. 11. a neděle 8. 11. 2026';

/** Krátce do řádku „Termín“ – časy se doplní z rezervačního systému. */
export const CHRISTMAS_DATES_SHORT = '7. a 8. 11. 2026';

export const CHRISTMAS_INTRO =
  'Vánoční focení na zámku Brandýs nad Orlicí u připravené vánoční scény – ' +
  'pro rodiny, páry i jednotlivce. Vyberte si volný čas a zbytek nechte na mně – ' +
  'budu ráda, když si odnesete fotky plné smíchu a pohody.';

// ─── Pomocné funkce (není potřeba upravovat) ───────────────────────────────

/** Dnešní datum v Praze jako „YYYY-MM-DD“ – nezávisle na časovém pásmu návštěvníka. */
export function pragueToday(now: Date = new Date()): string {
  try {
    // Po částech, ne přes format() – výsledný zápis data se mezi prohlížeči
    // a verzemi liší (en-CA kdysi v Chrome přestal vracet YYYY-MM-DD)
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Prague',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(now);
    const part = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
    return `${part('year')}-${part('month')}-${part('day')}`;
  } catch {
    // Prohlížeč bez podpory časových pásem – stačí místní datum
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  }
}

/** Má se sekce (a odkazy na ni) ještě zobrazovat? */
export function isChristmasActive(now: Date = new Date()): boolean {
  return SHOW_CHRISTMAS && now.getTime() >= Date.parse(CHRISTMAS_STARTS) && pragueToday(now) < CHRISTMAS_ENDS;
}

/** 1500 → „1.500 Kč“ – stejný zápis jako v ceníku. */
export function formatCzk(amount: number): string {
  const [whole, decimals] = amount.toFixed(Number.isInteger(amount) ? 0 : 2).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${grouped}${decimals ? `,${decimals}` : ''} Kč`;
}
